"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FilterCategoryMobile;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _dropdown = _interopRequireDefault(require("@ux/dropdown"));
var _react2 = require("@linaria/react");
const {
  DropdownItem
} = _dropdown.default;
const DropdownContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "DropdownContainer",
  class: "pl-dbq9xj4"
});
function FilterCategoryMobile({
  categoryList,
  handleCategorySelection,
  categoryCounts,
  checkedCategory,
  dropdownProps
}) {
  return /*#__PURE__*/_react.default.createElement(DropdownContainer, {
    "data-cy": "gtld-category-dropdown"
  }, /*#__PURE__*/_react.default.createElement(_dropdown.default, (0, _extends2.default)({
    id: "gtld-mobile-dropdown",
    "data-cy": "gtld-mobile-dropdown",
    type: "select",
    selected: [categoryList.findIndex(category => category.id === checkedCategory)],
    enableFullscreen: false
  }, dropdownProps), categoryList && categoryList.map(({
    value,
    id,
    name
  }) => /*#__PURE__*/_react.default.createElement(DropdownItem, {
    id: `category-${id}`,
    key: `category-${id}`,
    "data-cy": `category-item`,
    value: value,
    onClick: handleCategorySelection(id)
  }, `${name} (${categoryCounts[id]})`))));
}
FilterCategoryMobile.propTypes = {
  checkedCategory: _propTypes.default.number,
  handleCategorySelection: _propTypes.default.func,
  categoryCounts: _propTypes.default.object,
  categoryList: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    value: _propTypes.default.string,
    id: _propTypes.default.number,
    name: _propTypes.default.string,
    checked: _propTypes.default.bool
  })),
  dropdownProps: _propTypes.default.shape(_dropdown.default.propTypes)
};